module.exports = __webpack_public_path__ + "static/img/bgs.77ef138.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/bgs.jpg
// module id = x1zx
// module chunks = 1